/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Centro de Amizade",
      "Faça novos amigos com o Bumble For Friends | Bumble",
      "Baixe na App Store",
      "Baixe na Google Play",
      "Um lugar para fazer novas amizades",
      "Descubra pessoas perto de você que estão aqui para criar conexões autênticas.",
      "Encontre amizades para todas as fases da vida",
      "Acabou de se mudar? Procura um recomeço? Novas pessoas esperam por você!",
      "Um lugar seguro para todos",
      "Damos as boas-vindas a você em um espaço de respeito, onde você pode simplesmente ser você.",
      "Baixe o app",
      "Conheça pessoas que compartilham seus interesses!",
      "Conheça um novo grupo de pessoas com os Plans no Bumble For Friends",
      "Queremos te convidar para entrar no Plans",
      "O Plans é um novo recurso do Bumble For Friends onde você pode criar e participar de encontros em grupo com novas amizades perto de você",
      "Gerenciar Cookies",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "dias"
            ],
            "singular": [
                  "dia"
            ]
      },
      "hour": {
            "plural": [
                  "horas"
            ],
            "singular": [
                  "hora"
            ]
      },
      "minute": {
            "plural": [
                  "minutos"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "meses"
            ],
            "singular": [
                  "mês"
            ]
      },
      "second": {
            "plural": [
                  "segundos"
            ],
            "singular": [
                  "segundo"
            ]
      },
      "year": {
            "plural": [
                  "anos"
            ],
            "singular": [
                  "ano"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
